export default __webpack_public_path__ + "static/media/pot.16ee2f51.png";